import { IContractAddress } from '../entities/IContractAddress';
import { ILocation } from '../entities/ILocation';
import { httpClient } from './helper/httpClient';

export interface ICreateLocationParams {
  name: string;
  address?: IContractAddress | null;
}

export interface IUpdateLocationParams {
  name?: string;
  address?: IContractAddress | null;
}

class LocationService {
  private _baseURL = 'locations';

  getAll(): Promise<ILocation[]> {
    return httpClient.get<null, ILocation[]>(this._baseURL);
  }

  create(data: ICreateLocationParams): Promise<ILocation> {
    return httpClient.post<null, ILocation>(this._baseURL, { ...data });
  }

  update(id: string, data: IUpdateLocationParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, { ...data });
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }
}

export default new LocationService();
